import {isNil} from 'ramda';

import {Nullish} from 'shared/web';

import {MAX_THUMBNAIL_SLOTS} from '../../../constants/MAX_THUMBNAIL_SLOTS';
import {MIN_THUMBNAIL_SLOTS} from '../../../constants/MIN_THUMBNAIL_SLOTS';
import {THUMBNAIL_GAP_PX} from '../../../constants/THUMBNAIL_GAP_PX';
import {THUMBNAIL_MIN_WIDTH_PX} from '../../../constants/THUMBNAIL_MIN_WIDTH_PX';

/**
 * How many thumbnail tiles fit one row of the given width. The row never wraps: the last tile
 * becomes a "+N" tile when the photos do not fit, so a narrow preview just shows fewer tiles.
 */
export const getThumbnailSlotCount = (width: number | Nullish) => {
  if (isNil(width) || width <= 0) {
    return MAX_THUMBNAIL_SLOTS;
  }

  const fitting = Math.floor(
    (width + THUMBNAIL_GAP_PX) / (THUMBNAIL_MIN_WIDTH_PX + THUMBNAIL_GAP_PX)
  );

  return Math.min(MAX_THUMBNAIL_SLOTS, Math.max(MIN_THUMBNAIL_SLOTS, fitting));
};
